var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/modal/modal.tsx";
import classNames from 'classnames';
import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Button from '../button/button';
import IconButton from '../icon-button/icon-button';
const messages = defineMessages({
  close: {
    "id": "lightbox.close",
    "defaultMessage": "Close"
  },
  confirm: {
    "id": "confirmations.delete.confirm",
    "defaultMessage": "Delete"
  }
});
const widths = {
  xs: 'max-w-xs',
  sm: 'max-w-sm',
  md: 'max-w-base',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl'
};
/** Displays a modal dialog box. */
const Modal = ({
  cancelAction,
  cancelText,
  children,
  closeIcon = require('@tabler/icons/x.svg'),
  closePosition = 'right',
  confirmationAction,
  confirmationDisabled,
  confirmationText,
  confirmationTheme,
  onClose,
  secondaryAction,
  secondaryDisabled = false,
  secondaryText,
  skipFocus = false,
  title,
  width = 'xl'
}) => {
  const intl = useIntl();
  const buttonRef = React.useRef(null);
  React.useEffect(() => {
    if (buttonRef?.current && !skipFocus) {
      buttonRef.current.focus();
    }
  }, [skipFocus, buttonRef]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "modal",
    className: classNames('block w-full p-6 mx-auto text-left align-middle transition-all bg-white dark:bg-slate-800 text-black dark:text-white shadow-xl rounded-2xl pointer-events-auto max-h-screen overflow-y-auto', widths[width]),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm:flex sm:items-start w-full justify-between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 9
    }
  }, title && /*#__PURE__*/React.createElement("div", {
    className: classNames('w-full flex items-center gap-2', {
      'flex-row-reverse': closePosition === 'left'
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: "flex-grow text-lg leading-6 font-medium text-gray-900 dark:text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 15
    }
  }, title), onClose && /*#__PURE__*/React.createElement(IconButton, {
    src: closeIcon,
    title: intl.formatMessage(messages.close),
    onClick: onClose,
    className: "text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-200",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 17
    }
  })), title ? /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 13
    }
  }, children) : children)), confirmationAction && /*#__PURE__*/React.createElement("div", {
    className: "mt-5 flex flex-row justify-between",
    "data-testid": "modal-actions",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 11
    }
  }, cancelAction && /*#__PURE__*/React.createElement(Button, {
    theme: "ghost",
    onClick: cancelAction,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 15
    }
  }, cancelText || 'Cancel')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row space-x-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 11
    }
  }, secondaryAction && /*#__PURE__*/React.createElement(Button, {
    theme: "secondary",
    onClick: secondaryAction,
    disabled: secondaryDisabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 15
    }
  }, secondaryText), /*#__PURE__*/React.createElement(Button, {
    theme: confirmationTheme || 'primary',
    onClick: confirmationAction,
    disabled: confirmationDisabled,
    ref: buttonRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 13
    }
  }, confirmationText))));
};
export default Modal;